import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { ISalonDetailsApi } from '@app/salon-details/models/salon-details-api.model';
import { IVisitReviewTokenCheckInfo } from '@app/visit-reviews/models';
import { VisitReviewsService } from '@app/visit-reviews/services/visit-reviews.service';
import { SalonService } from '@app/shared/services/salon/salon.service';
import { Observable, forkJoin, of, EMPTY, switchMap, catchError } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class AddReviewTokenResolver implements Resolve<[IVisitReviewTokenCheckInfo, ISalonDetailsApi]> {

  constructor(
    private visitReviewService: VisitReviewsService,
    private salonDetailsService: SalonService,
    private router: Router) { }

  resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<[IVisitReviewTokenCheckInfo, ISalonDetailsApi]> {
    const token = route.paramMap.get('addReviewToken');
    return this.visitReviewService.checkAddReviewToken(token)
      .pipe(
        switchMap((tokenCheckInfo: IVisitReviewTokenCheckInfo) => {
          if (tokenCheckInfo.isTokenValid) {
            return forkJoin([of(tokenCheckInfo), this.salonDetailsService.getSalonDetails$(tokenCheckInfo.salonId)]);
          }
          return forkJoin([of(tokenCheckInfo), of(null)]);
        }),
        catchError(() => {
          this.router.navigate(['/']);
          return EMPTY;
        }));
  }

}
